import { memo, useCallback, useEffect, useRef, useState } from "react";
import { KnowledgeBaseState } from "../../../reducers/knowledgeBase.reducer";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Error from "../Error";

const Content = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoader] = useState<boolean>(true);
  const knowledgeBase: KnowledgeBaseState = useSelector((state: any) => state.knowledgeBase);

  const getPublishedURL = useCallback(() => {

    const selectedURLPath = knowledgeBase.activeURL.replaceAll(knowledgeBase.urls.app.split('~')[0], '')

    if (!knowledgeBase.urls.published && !knowledgeBase.urls.public) {
      setError(true);
      setLoader(false);
      return '';
    } 

    const publishedURL = new URL(knowledgeBase.urls.published || knowledgeBase.urls.public);

    return `https://${publishedURL.hostname}/${selectedURLPath}`

  }, [knowledgeBase]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const handleLoad = () => {
        setLoader(false);
      };

      iframe.addEventListener('load', handleLoad);

      return () => {
        iframe.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return (
    <>
      {
        loading && <div id='ele-62' className="flex items-center justify-center h-full"><CircularProgress /></div>
      }
      {
        error
          ? <div id='ele-63' className="flex items-center justify-center h-full"><Error type="Knowledge Base"></Error></div>
          : <iframe
            id='ele-64'
            ref={iframeRef}
            title="help"
            src={getPublishedURL()}
            className="h-full w-full hide-scrollbar rounded-t-md"
          ></iframe>
      }

    </>
  )
}

export default memo(Content);

